import script from "./ComSuunnittelutiedot.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComSuunnittelutiedot.vue?vue&type=script&setup=true&lang=ts"

import "./ComSuunnittelutiedot.vue?vue&type=style&index=0&id=cdb4b166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb4b166"]])

export default __exports__